import { Action } from '@ngrx/store';

/**
 * LayoutActionTypes
 */
export const enum LayoutActionTypes {
  TOGGLE_SIDENAV = '[Layout] Toggle Sidenav',
  OPEN_SIDENAV = '[Layout] Open Sidenav',
  CLOSE_SIDENAV = '[Layout] Close Sidenav',
}

/**
 * ToggleSidenav
 */
interface ToggleSidenav extends Action {
  type: LayoutActionTypes.TOGGLE_SIDENAV;
  target: string;
}

/**
 * OpenSidenav
 */
interface OpenSidenav extends Action {
  type: LayoutActionTypes.OPEN_SIDENAV;
  target: string;
}

/**
 * CloseSidenav
 */
interface CloseSidenav extends Action {
  type: LayoutActionTypes.CLOSE_SIDENAV;
  payload: any;
}

/**
 * LayoutActions
 */
export type LayoutActions = ToggleSidenav | OpenSidenav | CloseSidenav;
